
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[place]",
      function () {
        return require("private-next-pages/[place].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[place]"])
      });
    }
  